import { useQuery } from '@tanstack/react-query';

import UsersService from '~/services/UsersService';

import { usersQueryKeys } from './usersQueryKeys';

export function useGetAccountIdentities(accountId: string) {
  return useQuery({
    queryKey: usersQueryKeys.accountIdentityList(accountId),
    queryFn: ({ signal }) => UsersService.getAccountIdentities(accountId, { signal }),
    enabled: Boolean(accountId),
  });
}
